import { render, staticRenderFns } from "./UiFilePreview.vue?vue&type=template&id=ff8a3e46&lang=pug&"
import script from "./UiFilePreview.vue?vue&type=script&lang=js&"
export * from "./UiFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports